import { render, staticRenderFns } from "./msgInviteCom.vue?vue&type=template&id=ed95c114"
import script from "./msgInviteCom.vue?vue&type=script&lang=js"
export * from "./msgInviteCom.vue?vue&type=script&lang=js"
import style0 from "./msgInviteCom.vue?vue&type=style&index=0&id=ed95c114&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed95c114')) {
      api.createRecord('ed95c114', component.options)
    } else {
      api.reload('ed95c114', component.options)
    }
    module.hot.accept("./msgInviteCom.vue?vue&type=template&id=ed95c114", function () {
      api.rerender('ed95c114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/leftTopCom/msgInviteCom.vue"
export default component.exports